import { EUserRole } from '../../types/user';

/**
 * Является ли пользователь админом или модератором Журнала
 */
export const isAdminOrModerator = (roles: EUserRole[]): boolean => {
  return roles.some(role => role === EUserRole.Admin || role === EUserRole.Moderator);
};
